import { getBucketRange } from 'features/charts/utils/getBucketRange'

export const getTooltipLabel = (label: string, data: any, bucketBy: Bucket | undefined) => {
    const value = Array.isArray(data) ? data?.[0]?.payload?.key : data?.payload?.key
    return bucketBy ? getBucketRange(value, label, bucketBy) : label
}
